module.exports = __webpack_public_path__ + "media/images/icons/zoom-3eb57ba6a779dec6b37dae8679d2be10.png";